module.exports = "pegasus/assets/blocks/image-1-theme2.png";